import { useTranslation } from 'react-i18next';
import { QUESTION_PRIORITIES } from '../models/QAndA';
import { useMemo } from 'react';

const useQuestionsPriority = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t('high'), value: QUESTION_PRIORITIES.HIGH },
      { label: t('medium'), value: QUESTION_PRIORITIES.MEDIUM },
      { label: t('low'), value: QUESTION_PRIORITIES.LOW },
    ],
    [t],
  );
};

export default useQuestionsPriority;
